import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchLeagueIfNeeded} from '../../../../../../actions/app/other/mpp/league';
import {updateMPPLeague} from '../../../../../../actions/entities/league';
import Loader from '../../../../../../components/Loader';
import {copyTextToClipboard} from '../../../../../../helpers/utils';
import selectEntities from '../../../../../../selectors/entities';
import TableRow from '../../../../../Support/components/TableRow';
import {UserInfoStyles} from '../../../../../Support/User/components/Info/styles';
import {getChampionships} from '../../../../../../actions/entities/championships';

import './LeagueInfoWidget.css';

const statuses = {
  1: 'Créé',
  3: 'Lancée',
  4: 'Live',
  5: 'Terminé',
};

class LeagueInfoWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {contestId: props.contestId || ''};
  }

  fetchLeagueInfo(e) {
    if (e) e.preventDefault();
    const {contestId} = this.state;

    this.props.dispatch(fetchLeagueIfNeeded({contestId: contestId}));
    this.props.dispatch(getChampionships());
  }

  displayRequestMessage(info = this.props.widget.info) {
    if (info.error) {
      switch (info.error) {
        case 'leagueNotFound':
          break;
        default:
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong with: "${info.lastAction}"<br/>` +
              `<pre style="text-align: left">
                            <code>${JSON.stringify(info, undefined, 4)}</code>
                        </pre>`,
          });
      }
    }
  }

  static copyToClipboard(email) {
    const success = copyTextToClipboard(email);
    success
      ? swal(`Copied!`, `${email} is in your clipboard.`, 'success')
      : swal(`Oops...`, `We couldn't copy ${email}`, 'error');
  }

  componentDidMount() {
    if (this.state.contestId) this.fetchLeagueInfo();
  }

  componentWillReceiveProps(nextProps) {
    const {info} = this.props.widget;
    const nextInfo = nextProps.widget.info;

    if (info.success !== nextInfo.success || info.error !== nextInfo.error)
      this.displayRequestMessage(nextInfo);
  }

  renderNoResult() {
    const {info} = this.props.widget;
    const {error} = info;

    return (
      <div className="no-result text-center">
        <h4 className="text-muted">Want to find a particular MPP league ?</h4>
        <form className="form-inline" onSubmit={e => this.fetchLeagueInfo(e)}>
          <div
            className={classNames('form-group', {
              'has-error': error === 'leagueNotFound',
            })}>
            <div className="input-group input-group">
              <input
                type="text"
                className="form-control"
                placeholder="qFLv1HS36eh"
                value={this.state.contestId}
                onChange={e => this.setState({contestId: e.target.value})}
              />
              <span className="input-group-btn">
                <button
                  type="button"
                  className="btn btn-primary btn-flat"
                  onClick={this.fetchLeagueInfo.bind(this)}>
                  <i className="fa fa-search" />
                </button>
              </span>
            </div>
            {error === 'leagueNotFound' && (
              <span className="help-block">
                We couldn't find league {info.lastPayload.contestId}
              </span>
            )}
          </div>
        </form>
      </div>
    );
  }

  renderBody() {
    const {league} = this.props;
    const {entity} = league;

    if (!entity) return this.renderNoResult();

    const isChallenge = entity.type === 'mpp_challenge';

    const championshipName = this.props.championship?.lang['fr-FR']?.shortName;

    const imageUrlAction = (
      <div style={UserInfoStyles.avatarActionsContainer}>
        <button
          className="btn btn-warning"
          onClick={() =>
            this.props.dispatch(
              updateMPPLeague(
                {resetAvatar: true},
                entity.type + '_' + entity.id,
                () => {
                  this.props.dispatch(
                    fetchLeagueIfNeeded({contestId: entity.id}),
                  );
                },
              ),
            )
          }>
          set to default
        </button>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginLeft: 8,
          }}>
          <div>locked</div>
          <input
            style={{minWidth: 0}}
            type="checkbox"
            checked={entity.lockedImage}
            onChange={() =>
              this.props.dispatch(
                updateMPPLeague(
                  {lockedImage: !entity.lockedImage},
                  entity.type + '_' + entity.id,
                  () => {
                    this.props.dispatch(
                      fetchLeagueIfNeeded({contestId: entity.id}),
                    );
                  },
                ),
              )
            }
          />
        </div>
      </div>
    );

    return (
      <div className="result">
        <h3>Players</h3>
        <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <TableRow label="id" value={entity.id} />
          <TableRow label="admin" value={entity.adminId} />
          <TableRow label="createdAt" value={entity.createdAt} />
          <TableRow label="name" value={entity.name} />
          <TableRow label="description" value={entity.description} />
          <TableRow label="championship" value={championshipName} />
          <TableRow
            label="avatar"
            value={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}>
                <img
                  style={{maxWidth: 100, marginBottom: 8}}
                  src={entity.imageUrl}
                  alt=""
                />
                <button
                  className="btn btn-info"
                  onClick={() => copyTextToClipboard(entity.imageUrl)}>
                  Copy url
                </button>
              </div>
            }
            action={imageUrlAction}
          />
          <TableRow label="type" value={isChallenge ? 'Classique' : '1v1'} />
          <TableRow label="status" value={statuses[entity.status]} />
          <TableRow label="bonus activé" value={entity?.gameSettings?.bonuses?.doublePoints > 0 ? 'Yes' : 'No'} />
          <TableRow label="dates" value={`J${entity?.gameSettings?.firstGameWeekNumber} à J${entity?.gameSettings?.lastGameWeekNumber}`} />
          {/* {isChallenge ? 
            <tr key="isPublic">
              <td style={styles.value}>public league</td>
              <td>
                <i
                  onClick={() =>
                    this.props.dispatch(
                      updateMPPLeague(
                        {isPublic: !entity.isPublic},
                        entity.id,
                        () => {
                          this.props.dispatch(
                            fetchLeagueIfNeeded({contestId: entity.id}),
                          );
                        },
                      ),
                    )
                  }
                  className={classNames('fa fa-2x', {
                    'fa-toggle-on': entity.isPublic,
                    'fa-toggle-off': !entity.isPublic,
                  })}
                />
              </td>
            </tr> 
          : null} */}
          <TableRow 
            label="non joinable" 
            value={
              <i
                onClick={() =>
                  this.props.dispatch(
                    updateMPPLeague(
                      {isJoinClosed: !entity.isJoinClosed},
                      entity.type + '_' + entity.id,
                      () => {
                        this.props.dispatch(
                          fetchLeagueIfNeeded({contestId: entity.id}),
                        );
                      },
                    ),
                  )
                }
                className={classNames('fa fa-2x', {
                  'fa-toggle-on': entity.isJoinClosed,
                  'fa-toggle-off': !entity.isJoinClosed,
                })}
              />
            }
          />
          <TableRow label="users quantity" value={entity?.usersQuantity} />
        </tbody>
      </table>
        <table className="table table-sm table-responsive table-striped">
          <thead>
            <tr>
              <th>user ID</th>
              <th>Username</th>
              <th>Email</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {entity.seasonUsers.map((item, key) => (
              <tr key={key}>
                <td>{item.userId}</td>
                <td>{item.username}</td>
                <td>{item.email}</td>
                <td>
                  <button
                    className="btn btn-xs btn-primary"
                    title="Copy to clipboard"
                    onClick={() => LeagueInfoWidget.copyToClipboard(item.username)}
                    data-toggle="tooltip"
                    data-placement="top"
                    data-containert="body">
                    <i className="fa fa-clipboard" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderFooter() {
    const {entity} = this.props.league;

    return (
      entity && (
        <div className="box-footer form-inline">
          <form
            onSubmit={e => this.fetchLeagueInfo(e)}
            className="input-group margin-r-5 pull-right">
            <input
              type="text"
              className="form-control"
              placeholder="qqAAbGUlC9L"
              value={this.state.contestId}
              onChange={e => this.setState({contestId: e.target.value})}
            />
            <span className="input-group-btn">
              <button
                type="button"
                className="btn btn-default btn-flat"
                onClick={this.fetchLeagueInfo.bind(this)}>
                <i className="fa fa-search" />
              </button>
            </span>
          </form>
        </div>
      )
    );
  }

  render() {
    const {info} = this.props.widget;

    return (
      <div id="league-info-widget" className="row">
        <div className="col-md-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-info-circle" /> League info
              </h3>
            </div>
            <div className="box-body">{this.renderBody()}</div>
            {this.renderFooter()}
            {info.isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

LeagueInfoWidget.propTypes = {
  contestId: PropTypes.string,
};

export default connect(
  state => {
    const {leaguesMPP} = state.entities;
    const widget = state.app.other.mpp.league;
    const {championships} = state.app;
    const entity =  selectEntities(leaguesMPP, [widget.id])[0];

    return {
      widget,
      league: {entity: selectEntities(leaguesMPP, [widget.id])[0]},
      championship:
        championships.list.data?.[entity?.gameSettings?.championshipId],
    };
  },
  dispatch => ({dispatch}),
)(LeagueInfoWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/League/Widgets/LeagueInfo/index.js